export default __webpack_public_path__ + "alarm-ffb579.mp3";